import { render, staticRenderFns } from "./TierMatchingAmountInput.vue?vue&type=template&id=70497536&"
import script from "./TierMatchingAmountInput.vue?vue&type=script&lang=js&"
export * from "./TierMatchingAmountInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports